/* eslint-disable no-throw-literal */
import {
  GET_SERVICE_QUESTION_CATEGORY_ALL,
  GET_SERVICE_QUESTION_CATEGORY_ALL_FAILURE,
  GET_SERVICE_QUESTION_CATEGORY_ALL_SUCCESS
} from './mutation-types'

export default {
  state: {
    serviceQuestionCategories: []
  },
  getters: {
    serviceQuestionCategories: state => {
      return state.serviceQuestionCategories
    }
  },
  actions: {
    async [GET_SERVICE_QUESTION_CATEGORY_ALL] ({ dispatch, commit }) {
      const res = await dispatch('apiGet', { url: '/master/services/service_question_categories' })
      if (res.status === 200 || res.status === 304) {
        if (res.data.error) {
          commit(GET_SERVICE_QUESTION_CATEGORY_ALL_FAILURE)
        } else {
          commit(GET_SERVICE_QUESTION_CATEGORY_ALL_SUCCESS, {data: res.data})
        }
      }
    }
  },
  mutations: {
    [GET_SERVICE_QUESTION_CATEGORY_ALL_FAILURE] () {
      console.log('GET_SERVICE_QUESTION_CATEGORY_ALL_FAILURE')
    },
    [GET_SERVICE_QUESTION_CATEGORY_ALL_SUCCESS] (state, params) {
      console.log('GET_SERVICE_QUESTION_CATEGORY_ALL_SUCCESS')
      const data = params.data
      console.log(data)
      state.serviceQuestionCategories = data.categories
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/service-question-category.js